module.exports = __webpack_public_path__ + "img/es.9b4f8066.jpg";